import React from "react";
import SEO from "./SEO.jsx";

// Neutral full-page message for protected admin pages (loading / errors).
export default function AdminStatus({ message, detail }) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 pt-28 pb-16">
      <SEO title="2merative Admin" description="2merative admin area." path="/private/login" noindex />
      <div className="text-center" role="status" aria-live="polite">
        <p className="text-gray-700 font-medium">{message}</p>
        {detail && <p className="mt-2 text-sm text-gray-500">{detail}</p>}
      </div>
    </div>
  );
}
